<template>
  <el-select
    v-model="selected"
    size="small"
    filterable
    remote
    multiple
    @change="handleChange"
    :remote-method="requestData"
    :loading="loading"
    placeholder="搜索并选择"
    style="width: 100%"
    :popper-append-to-body="false"
  >
    <el-option
      v-for="item in lists"
      :key="item.id"
      :label="item.serial_number"
      :value="item.serial_number"
    ></el-option>
  </el-select>
</template>

<script>
import { drillList } from '../../service/getData'

export default {
  props: {
    value: Array,
    eventkey: Number,
  },
  watch: {
    value: function (n, o) {
      if (!n) {
        this.selected = []
      } else if (n.length > 0 && !o) {
        this.requestDefaultOption()
      }
    },
  },
  data() {
    return {
      selected: [],
      lists: [],
      loading: false,
    }
  },
  created() {
    if (this.value && this.value.length > 0) {
      this.requestDefaultOption('', this.value)
    }
  },
  methods: {
    handleChange() {
      this.$emit('input', this.selected || [])
    },
    async requestDefaultOption() {
      let res = await drillList({
        serial_numbers: this.value.join(','),
      })

      this.lists = res.data.list
      this.selected = this.value
    },
    async requestData(query) {
      if (query !== '') {
        this.loading = true
        let data = {
          serial_number: query,
        }
        let res = await drillList(data)
        this.loading = false
        this.lists = res.data.list
      }
    },
  },
}
</script>